import { render } from "./ConsentBox.vue?vue&type=template&id=ead812b0"
import script from "./ConsentBox.vue?vue&type=script&lang=js"
export * from "./ConsentBox.vue?vue&type=script&lang=js"

import "./ConsentBox.vue?vue&type=style&index=0&id=ead812b0&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__